/**
 * Next free sibling order for a widget appended to a container: one past the
 * highest existing order, or 0 for the first child.
 *
 * Why max+1 and not `siblings.length`: existing data can hold gaps and ties
 * (widgets saved before an order was assigned all share 0), so length-based
 * numbering could collide with an existing value and re-introduce a tie.
 *
 * @param {Array<{order?: number}>} siblings - Current children of the target container
 * @returns {number} Order value for the new widget
 */
const nextSiblingOrder = (siblings) => {
    if (siblings.length === 0) return 0;
    return Math.max(...siblings.map(s => Number(s.order) || 0)) + 1;
};

export { nextSiblingOrder };
